import React from 'react';
import { Header } from '../../features/header/Header';
import styled from 'styled-components';

import { Container, Table } from 'reactstrap';

const FieldName = styled.th`
  width: 25%;
`;

function FepNonLinearFieldSpecPage() {
  return (
    <>
      <Header />
      <Container>
        <h2 className="mb-4">Upload File Format</h2>
        <h3 className="mb-4">Required Fields</h3>
        <Table>
          <thead>
            <tr>
              <FieldName>Field</FieldName>
              <th>Examples</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Identifier Type</th>
              <th>ISIN, CUSIP</th>
            </tr>
            <tr>
              <td>Identifier</td>
              <td>XS1472483772, US92857WBJ80</td>
            </tr>
            <tr>
              <td>Trade Date &amp; Time</td>
              <td>2015-08-29T11:22:09.815479+01:00</td>
            </tr>
            <tr>
              <td>Trade Price</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Side</td>
              <td>B, S, Buy, Sell</td>
            </tr>
            <tr>
              <td>Notional Traded</td>
              <td>2500000</td>
            </tr>
          </tbody>
        </Table>
        <h3 className="mb-4">Optional Fields</h3>
        <Table>
          <thead>
            <tr>
              <FieldName>Field</FieldName>
              <th>Examples</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Order ID</td>
              <td>1234567, A1B2C3</td>
            </tr>
            <tr>
              <td>Trade ID</td>
              <td>7654321, Z9Y8X7</td>
            </tr>
            <tr>
              <td>Portfolio ID</td>
              <td>EU122480, EM011521</td>
            </tr>
            <tr>
              <td>Other ID</td>
              <td>A12345</td>
            </tr>
            <tr>
              <td>Order Date &amp; Time</td>
              <td>2015-08-29T11:22:09.815479+01:00</td>
            </tr>
            <tr>
              <td>Other Date &amp; Time</td>
              <td>2015-08-29T11:22:09.815479+01:00</td>
            </tr>
            <tr>
              <td>Order Type</td>
              <td>Market, Discretionary</td>
            </tr>
            <tr>
              <td>Trade Type</td>
              <td>Electronic, Voice</td>
            </tr>
            <tr>
              <td>Underlying Benchmark</td>
              <td>10 Year Treasury Note</td>
            </tr>
            <tr>
              <td>Explicit Cost</td>
              <td>3.75, 0.25</td>
            </tr>
            <tr>
              <td>Security Type</td>
              <td>Corporate Bond, Agency Bond, Government Bond</td>
            </tr>
            <tr>
              <td>Security Sub Type</td>
              <td>US HG, US HY, EUR Euro, GBP Euro, EM USD, EM Local</td>
            </tr>
            <tr>
              <td>Instrument Type</td>
              <td>U.S. Treasury bill (UTB)</td>
            </tr>
            <tr>
              <td>Description</td>
              <td>
                BACR 4.836 05/09/28, 10YR Treasury Note 1.75% 2029-11-15, UKT
                0.625 06/25
              </td>
            </tr>
            <tr>
              <td>Price Type</td>
              <td>Price, Rate, Spread, Yield</td>
            </tr>
            <tr>
              <td>Trade Capacity</td>
              <td>Agency, Principal, Match Principal</td>
            </tr>
            <tr>
              <td>Trader Name/ID/Code</td>
              <td>JSMITH, E2468</td>
            </tr>
            <tr>
              <td>PM / Portfolio Manager</td>
              <td>MPETER, EM623D</td>
            </tr>
            <tr>
              <td>Desk/Location</td>
              <td>NYC, LON</td>
            </tr>
            <tr>
              <td>Dealer or Broker</td>
              <td>GS, JPM, TPICAP</td>
            </tr>
            <tr>
              <td>Platform or Venue</td>
              <td>Bloomberg, TW, MKTX</td>
            </tr>
            <tr>
              <td>Cover Price</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Limit Price</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Event Type</td>
              <td>Rebalance, News, Announcement, Interest Rates</td>
            </tr>
            <tr>
              <td>Instructions</td>
              <td>Discretion, Market</td>
            </tr>
            <tr>
              <td>Status</td>
              <td>Live, Closed</td>
            </tr>
            <tr>
              <td>Account</td>
              <td>ABC, 123</td>
            </tr>
            <tr>
              <td>Fund (Fund Type)</td>
              <td>Flagship, XYZ</td>
            </tr>
            <tr>
              <td>Strategy (Strategy Type)</td>
              <td>Active, Passive</td>
            </tr>
            <tr>
              <td>Custom Benchmark 1</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Custom Benchmark 2</td>
              <td>97.25, 104.8565</td>
            </tr>
            <tr>
              <td>Other 1</td>
              <td></td>
            </tr>
            <tr>
              <td>Other 2</td>
              <td></td>
            </tr>
          </tbody>
        </Table>
      </Container>
    </>
  );
}

export default FepNonLinearFieldSpecPage;
